import React from "react";

const ProgressBar = ({ currentStep, totalSteps,className }) => {
  return (
    <div className="flex gap-1 items-center w-full">
      <div className={`flex flex-1 shrink gap-1 items-center self-stretch my-auto basis-0 min-w-[240px] ${className}`}>
        {[...Array(totalSteps)].map((_, index) => (
          <div
            key={index}
            className={`flex flex-1 shrink self-stretch my-auto h-2 rounded-2xl basis-0 ${
              index < currentStep
                ? "bg-[linear-gradient(163deg,#675DFF_-0.19%,#3A61EB_100.98%)]"
                : "bg-stone-200"
            } w-[91px]`}
          />
        ))}
      </div>
      <div className="self-stretch my-auto text-sm font-bold leading-relaxed text-neutral-500">
        <span className="text-zinc-800">{currentStep}</span>/{totalSteps}
      </div>
    </div>
  );
};

export default ProgressBar;